<script setup lang="ts">
interface Props {
  count?: number
}

const props = withDefaults(defineProps<Props>(), {
  count: 5
})
</script>

<template>
  <div class="space-y-4">
    <article
      v-for="n in props.count"
      :key="n"
      class="Card animate-pulse rounded-md border p-4 shadow-sm"
    >
      <div class="flex flex-col space-y-4">
        <div class="space-y-2">
          <div class="h-5 w-48 rounded bg-gray-300" />
          <div class="flex gap-1">
            <div class="h-6 w-20 rounded-full bg-gray-300" />
            <div class="h-6 w-20 rounded-full bg-gray-300" />
          </div>
        </div>

        <div class="grid grid-cols-2 gap-x-4 gap-y-3 md:grid-cols-3">
          <div class="h-4 w-24 rounded bg-gray-300" />
          <div class="h-4 w-24 rounded bg-gray-300" />
          <div class="h-4 w-24 rounded bg-gray-300" />
          <div class="h-4 w-24 rounded bg-gray-300" />
        </div>
      </div>
    </article>
  </div>
</template>
